import { formatPrismicData } from '@monofront/business/utils';
import { IStepsWithAnchors, NumberedStepsWithAnchorLinksProps } from './types';

export const mapStepsWithAnchors = ({
  prismicContent,
}: {
  prismicContent: NumberedStepsWithAnchorLinksProps;
}): IStepsWithAnchors => {
  const { primary, items }: IStepsWithAnchors =
    formatPrismicData(prismicContent);

  return {
    primary,
    items,
  };
};
